import React from 'react';
import { Col, Divider, Form, Input, Row, Typography, Radio } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoSection = ({ question }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={9}>
        <Typography.Title level={3}>{question?.title}</Typography.Title>
      </Col>
      {question?.is_input_text && (
        <Col span={15}>
          <Form.Item label={t('Titolo')} name={question?.id}>
            <Input placeholder={t('Inserisci testo')} />
          </Form.Item>
        </Col>
      )}
      {!question?.is_input_text && (
        <Col span={15}>
          <Form.Item name={question?.id}>
            <Radio.Group>
              {question?.question1 && (
                <Radio value={1}>{question?.question1}</Radio>
              )}
              {question?.question2 && (
                <Radio value={2}>{question?.question2}</Radio>
              )}
              {question?.question3 && (
                <Radio value={3}>{question?.question3}</Radio>
              )}
              {question?.question4 && (
                <Radio value={4}>{question?.question4}</Radio>
              )}
              {question?.question5 && (
                <Radio value={5}>{question?.question5}</Radio>
              )}
            </Radio.Group>
          </Form.Item>
          <Divider />
        </Col>
      )}
    </Row>
  );
};

export default React.memo(InfoSection);
